import {
  IncomingMessage,
  ListenerEvent,
  MessageHandler
} from '@carvana/merch-native';
import { useMemo } from 'react';
import useBudgetTradeIn from '@/srp/FiltersMenu/Budget/hooks/useBudgetTradeIn';
import { ListenerEventType } from './constants';

type ToggleTradeMessage = IncomingMessage<
  ListenerEventType,
  {
    isTradeInApplied: boolean;
  }
>;

function isToggleTradeMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is ToggleTradeMessage {
  return message.event === ListenerEvent.TradeInToggled;
}

export default function useToggleTradeHandler(): MessageHandler<ListenerEventType> {
  const toggleTrade = useBudgetTradeIn();

  return useMemo(
    () =>
      new MessageHandler(
        isToggleTradeMessage,
        (message: ToggleTradeMessage) => {
          toggleTrade(message.payload.isTradeInApplied);
        }
      ),
    [toggleTrade]
  );
}
